import { Metric } from '../types/content';

export const impactMetrics: Metric[] = [
  {
    value: 400,
    suffix: '+ MW',
    label: 'Utility-Scale Solar Subscriptions Commercialized Across 4 Major Installations'
  },
  {
    value: 9.5,
    prefix: '$',
    suffix: 'B+',
    decimals: 1,
    label: 'Enterprise Operating Scope Within Fortune 500 Utility Framework'
  },
  {
    value: 45,
    suffix: '+',
    label: 'Clean-Tech Innovation & Pilot Projects Scaled Across Business Units'
  },
  {
    value: 6000,
    suffix: '+',
    label: 'Industry Professionals Engaged Across 60 Monthly Innovation Sessions Over 6 Years'
  },
  {
    value: 60,
    suffix: '%',
    label: 'Employee Engagement Rate on Enterprise Ideation Platform, Doubling Industry Benchmarks'
  },
  {
    value: 33000,
    prefix: '$',
    suffix: '+',
    label: 'Annual Savings Generated via Custom Civic Data Automation Systems'
  }
];
